var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconListdots = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 12"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "List",
  transform: "translate(-1268 -132)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4015",
  "data-name": "Group 4015",
  transform: "translate(0 2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4013",
  "data-name": "Group 4013"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4867",
  "data-name": "Path 4867",
  d: "M1287,132h-12a1,1,0,0,1,0-2h12a1,1,0,0,1,0,2Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4014",
  "data-name": "Group 4014"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4868",
  "data-name": "Path 4868",
  d: "M1271,132h-2a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4018",
  "data-name": "Group 4018"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4016",
  "data-name": "Group 4016"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4869",
  "data-name": "Path 4869",
  d: "M1287,139h-12a1,1,0,0,1,0-2h12a1,1,0,0,1,0,2Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4017",
  "data-name": "Group 4017"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4870",
  "data-name": "Path 4870",
  d: "M1271,139h-2a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4021",
  "data-name": "Group 4021",
  transform: "translate(0 -2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4019",
  "data-name": "Group 4019"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4871",
  "data-name": "Path 4871",
  d: "M1287,146h-12a1,1,0,0,1,0-2h12a1,1,0,0,1,0,2Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4020",
  "data-name": "Group 4020"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4872",
  "data-name": "Path 4872",
  d: "M1271,146h-2a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z"
}))))));
export default SvgIconListdots;